import React from 'react';
import classes from './SimpleTableHeader.module.css';
import { ColumnType } from '../types';

type HeaderProps<T> = {
  columns: ColumnType<T>[];
};

const SimpleTableHeader = <T,>({ columns }: HeaderProps<T>) => {
  return (
    <thead>
      <tr className={classes.rowStyle}>
        {columns.map((column, index) => (
          <th
            key={index}
            style={{ textAlign: column.align ?? 'left' }}
            className={classes.headerCell}
          >
            {column.displayName}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export { SimpleTableHeader };
